export default [
  { label: 'Az Tehlikeli', id: 10 },
  { label: 'Tehlikeli', id: 20 },
  { label: 'Çok Tehlikeli', id: 30 },
  { label: 'Belirsiz', id: 40 },
];
